export default __webpack_public_path__ + "static/media/jest.976a7b2c.png";